
import React from 'react';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useProductPrice } from '../../context/store/queries';
import LocalePrice from '../../utils/LocalePrice';

export default function PriceDisplay({ sku }: { sku: string }) {
    const [price] = useProductPrice(sku);
    const { currentLocale } = usePageLocalization();
    if (!price) return <span>n/a</span>;

    return (
        <div className={`pricing ${price.discount && 'on-sale'}`}>
            {LocalePrice(currentLocale, price?.regularPrice.value)}
        </div>
    );
}
